import { withStyles } from "@material-ui/styles";
import { WithStyles } from "@material-ui/core";
import { styles } from "./GenerateMarketplaceTokenView.styles";
import React, { useState } from "react";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { Breadcrumbs } from "../../components/Breadcrumbs/Breadcrumbs";
import { useTranslation } from "react-i18next";
import Typography from "@material-ui/core/Typography/Typography";
import { BlueButton } from "../../components/Buttons/BlueButton";
import { useDispatch, useSelector } from "react-redux";
import * as InternalUserAction from "../../../stores/internal/InternalUserAction";
import ToastStatusEnum from "../../../constants/ToastStatusEnum";
import { useSnackbar } from "notistack";
import { MARKETPLACE_TOKEN } from "../../../constants/TOKENS";

export interface IGenerateMarketplaceTokenViewProps extends WithStyles<typeof styles> {

}

const GenerateMarketplaceTokenViewPure: React.FunctionComponent<IGenerateMarketplaceTokenViewProps> = ({classes}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar();

    const generatedMarketplaceToken = useSelector(state => state.internalUser.marketplaceToken);

    const [savedToClipboard, setSavedToClipboard] = useState(false);

    const generateNewToken = () => {
        dispatch(InternalUserAction.generateMarketplaceTokenForAdmin(MARKETPLACE_TOKEN));
    };

    const saveToClipboard = () => {
        navigator.clipboard.writeText(generatedMarketplaceToken.mp_api);
        if (!savedToClipboard) {
            setSavedToClipboard(true);
            enqueueSnackbar("Saved to clipboard", {
                variant: ToastStatusEnum.Info
            });
        }
    };

    return <CenteredContainer>
        <Breadcrumbs
            items={[
                {title: t("admin.adminPanel"), href: "/admin"},
                {title: "Marketplace token"}
            ]}
        />
        <div className={classes.title}>
            <Typography variant="h2">Marketplace token</Typography>
        </div>
        <div>
            {generatedMarketplaceToken
                ? <>
                    <Typography variant="h3">Your Marketplace token:</Typography>
                    <div>
                        <Typography variant="body2" className={classes.token}
                                    onClick={saveToClipboard}>{generatedMarketplaceToken.api_token}</Typography>
                        <br/>
                        <Typography variant="body2">Expiry: {generatedMarketplaceToken.expires_at}</Typography>
                    </div>
                </>
                : <Typography variant="body1">This token can be used to access the API programmatically. It has a validity of 1 year. After the generation please copy the token to a safe place, it will not be displayed again after this session. You can always create a new token.</Typography>
            }

        </div>
        <BlueButton onClick={generateNewToken}>
            Generate new token
        </BlueButton>

    </CenteredContainer>;
};

export const GenerateMarketplaceTokenView = withStyles(styles)(GenerateMarketplaceTokenViewPure);